<div [id]="htmlId()" class="section" [style.display]="isVisible() ? 'flex' : 'none'">
  @if (properties.allowCollapse) {
    <div class="icon-safe-zone" (click)="onToggleClick()" [class.clickable]="properties.allowCollapse">
      <mat-icon class="icon">{{ isOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>
  }
  <span [ngClass]="['title', properties.style.toLowerCase(), 'preserve-newlines']">{{ properties.text }}</span>
</div>
